import EF from 'ef/ef';
import View from 'views/base/view';
import FeedbackView from 'views/feedback/feedback-view';
import ActionBarView from 'views/actionbar/actionbar-view';
import { AlertView, AudioStarterAlertView } from 'views/alert/alert-view';
import CustomContentView from 'views/custom-content/custom-content-collection-view';
import BlocksView from 'views/block/block-collection-view';
import Feedback from 'models/feedback';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import { SessionStorageService } from 'services/data-handler-services/web-storage-service';
import Chaplin from 'chaplin';
import { KeybindingService, keys } from 'services/event-handler-services/keybinding-service';
import LocaleService from 'services/loader-handler-services/locale-service';
import ContentService from 'services/loader-handler-services/content-service';
import TranscriptView from 'views/transcript/transcript-view';
import FeedbackService from 'services/course-handler-services/feedback-service';
import PageService from 'services/page-service';
import AnimationService from 'services/event-handler-services/animation-service';
import PageTimerService from 'services/course-handler-services/page-timer-service';
import BlockOrderService from 'services/course-handler-services/block-order-service';
import utils from 'lib/utils';
import ContentProvider from 'services/content-provider';
import PageTemplate from './templates/page';
import TimeoutTemplate from './templates/timeout';
import AOS from 'aos';
import $ from 'jquery';
import _ from 'lodash';
import AniJS from 'AniJS';

const { Tab, Enter, Space } = keys;

const PageView = View.extend({
  autoRender: true,
  regions: {
    page: '#page-container',
    timer: '#timer-page',
    actionbar: '.actionbar',
    alert: '.alert',
    'audio-starter-alert': '.audio-starter-alert',
    siteTranscript: '.site-transcript',
    before: '.before-content',
    feedback: '.feedback',
    'custom-content': '.custom-content',
  },
  template: PageTemplate,
  listen: {
    'action:replay mediator': 'onReplay',
    'action:unload mediator': 'unload',
    'block:feedback mediator': 'renderFeedback',
    'action:alert mediator': 'renderAlert',
    'audio:play:blocked mediator': 'renderAudioStarterAlert',
  },
  initialize: async function (_options) {
    const self = this;

    utils.loadPageSRText(this.model.get('title'));

    if (CourseSettingsService.get('trackPageTimes') && !EF.options.local) {
      this.pageTimerService = new PageTimerService();
      this.pageTimerService.start();
    }
    if (CourseSettingsService.get('transcript')) {
      this.model.set('transcript', true);
    }
    if (CourseSettingsService.get('skipNavigationAccessibility')) {
      this.model.set('skipNavigationAccessibility', true);
    }
    if (CourseSettingsService.get('pageCompletion') && CourseSettingsService.get('pageCompletion').completeOnError) {
      this.subscribeEvent('application:error', _application => {
        if (self !== undefined && typeof self.completePage === 'function') {
          self.completePage();
        }
      });
    }

    BlockOrderService.reset();

    /**
     * CourseSettingsService.
     */

    const that = this;
    $('#site-container').addClass('focus-hide');
    this.delegate('click', '#transcript_button', function (e) {
      e.preventDefault();
      const self = this;
      if (this.transcriptShowing) {
        this.closeTranscript();
      } else {
        Chaplin.mediator.publish('action:pause');
        this.$('#transcript_button').addClass('open');
        const transcriptView = new TranscriptView({
          region: 'siteTranscript',
          model: this.model,
        });
        transcriptView.delegate('click', '.close', function () {
          self.closeTranscript();
          $('#transcript_button').trigger('focus');
        });
        this.subview('siteTranscript', transcriptView);
        this.$('.transcript').css('display', 'block');
        // something in the page view grabs focus again, so let's delay slightly
        setTimeout(() => {
          this.$('.transcript .text').attr('tabindex', '0').focus();
        }, 300);
        that.on('keydown', '.transcript .text', function (e) {
          KeybindingService.with(e).bind(Tab, () => {
            e.preventDefault();
            this.$('.transcript .close').attr('tabindex', '0').focus();
          });
        });
        this.transcriptShowing = true;
      }
    });
    utils.subAriaHiddenOnDialog(this, '#main-container');

    _.bindAll(this, 'setState');

    const linkedPage = this.model.get('link');
    const scriptPath = linkedPage
      ? ['modules', linkedPage.module, linkedPage.activity, linkedPage.page, linkedPage.page].join('/')
      : [
          'modules',
          this.model.get('moduleKey'),
          this.model.get('activityKey'),
          this.model.get('key'),
          this.model.get('key'),
        ].join('/');

    this.script = utils.tryRequire(scriptPath) || {};
    let accSettings;

    if (this.model.get('srContent')) {
      accSettings = CourseSettingsService.get('accessibility');
      if (accSettings && accSettings.skipKey) {
        this.model.set('skipKey', accSettings.skipKey);
        this.model.set('sr_skip_text', LocaleService.t('srSkipText'));
      }
    }

    if (this.model.get('custom-transcript')) {
      this.customTranscriptKey = this.model.get('custom-transcript');
    }

    this.delegate('keydown', function (e) {
      if ($(e.target).prop('tagName') !== 'INPUT' && accSettings && accSettings.skipKey) {
        KeybindingService.with(e).bind([accSettings.skipKey.toUpperCase(), accSettings.skipKey.toLowerCase()], () => {
          if (self.model.get('srContent') && e.shiftKey && e.ctrlKey) {
            self.completePage();
            Chaplin.mediator.publish('page:navigate', self.forwardKey());
          }
        });
      }
    });

    const $el = this.$el;
    if (this.model.get('transition-in')) {
      const transitionInDir = this.model.get('transition-in');
      $el.addClass(`transition-in-${transitionInDir}`);
      $el.on('animationstart', () => {
        $el.on('animationend', () => {
          //console.log(`finished animation in on ${this.model.get('key')}; removing class`);
          if ($el) {
            $el.removeClass(`transition-in-${transitionInDir}`);
          }
        });
      });
    }

    this.listenTo(this.model, 'change:state', function () {
      //TODO: review the timing of this; had to move it in FeedbackView to have it run after callbacks had happened
      self.trigger('page:state:change', self);
      if (self.model) {
        Chaplin.mediator.publish(`page:state:${self.model.get('state')}`, self);
      }
      Chaplin.mediator.publish('page:stateChange', self);
    });

    this.subscribeEvent('feedback:all:close', function () {
      for (let i = this.subviews.length - 1; i >= 0; i--) {
        if (this.subviews[i] instanceof FeedbackView) {
          this.removeSubview(self.subviews[i]);
        }
      }
    });

    this.subscribeEvent('alert:close', this.closeAlert);
    this.subscribeEvent('audio-starter-alert:close', this.closeAudioStarterAlert);

    this.subscribeEvent('page:complete', function (options) {
      self.completePage();
      self.publishEvent('page:navigate', options.direction);
    });

    if (CourseSettingsService.get('pageCompletion')) {
      const pageCompletion = CourseSettingsService.get('pageCompletion');
      if (pageCompletion.modal) {
        const openModal = function () {
          self.$('#timeout-modal-container').html(TimeoutTemplate);
          self.$('#timeout-modal').modal('show');
          self.delegate('click', '#timeout-modal .keep-working', () => {
            self.$('#timeout-modal').remove();
            clearTimeout(self.completionTimeout);
            self.completionTimeout = setTimeout(openModal, pageCompletion.timer);
          });
          self.delegate('click', '#timeout-modal .skip-page', () => {
            self.$('#timeout-modal').remove();
            self.completePage();
            Chaplin.mediator.publish('page:navigate', 'forward');
          });
        };
        this.completionTimeout = setTimeout(openModal, pageCompletion.timer);
      } else {
        self.completionTimeout = setTimeout(() => {
          self.completionTimerExpired = true;
          self.completePage();
        }, pageCompletion.timer);
      }
    }

    this.setState('initialized');
    const shouldBeSkipped = await PageService.shouldBeSkipped(this);
    if (shouldBeSkipped) {
      self.willBeSkipped = true; //defer page navigation until play begins
      self.completePage();
    }

    utils.applyAnimationProperty(this);
    View.prototype.initialize.apply(this, arguments);
    Chaplin.mediator.publish('page:initialized');
  },

  play: function () {
    if (this.willBeSkipped) {
      Chaplin.mediator.publish('page:navigate', 'skip');
    } else {
      this.setMainRole();
      this.setPrevNextTitle();

      //TODO: revisit trying to reuse the actionbarview, has been moved from the controller
      //this.reuse('actionbar', ActionBarView, {region: 'actionbar'});
      const group = EF.module.get('group');

      const m = new Chaplin.Model({
        groupTitle: group !== undefined ? group.get('title') : '',
        moduleTitle: EF.module.get('title'),
        pageTitle: this.model.get('title'),
        pageProgress: EF.module.getPageProgress(),
        navigation: this.model.get('navigation'),
      });

      const actionBarView = new ActionBarView({
        region: 'actionbar',
        model: m,
      });
      this.subview('actionbar', actionBarView);

      ContentService.applyContent(new Chaplin.Model(), 'modules')
        .then(bm => {
          // Check if a module-key exists on the modules atrribute and set it as the default block module if it exists
          const currentModule = EF.module.get('key');
          const modulesCollection = bm.get(currentModule) && bm.get(currentModule).blocks;
          return modulesCollection
            ? ContentService.applyContent(new Chaplin.Model(), `modules.${currentModule}`)
            : Promise.resolve(bm);
        })
        .then(bm => {
          let modulesBlocksView;
          if (bm.get('blocks')) {
            modulesBlocksView = new BlocksView({
              //eslint-disable-line no-unused-vars
              collection: bm.get('blocks'),
              region: 'before',
              parent: this,
              pageView: this,
            });
            this.subview('moduleBlocks', modulesBlocksView);
          }

          if (bm.get('blocks') && bm.get('blocks').length > 0) {
            this.setSkipLink();
          } else {
            this.$el.find('#skip-to-main-content').addClass('hidden');
          }

          const blocksView = new BlocksView({
            collection: this.model.get('blocks'),
            region: 'page',
            script: this.script ? this.script.block : undefined,
            parent: this,
            pageView: this,
          });

          this.subview('blocks', blocksView);
          this.listenTo(blocksView, 'block:state:completed', this.blockCompleted);
          this.listenTo(blocksView, 'page:state:change', () => {
            const narration = this.getBlocksNarration(this.model.get('blocks'));
            if (narration.length) {
              this.model.set('transcriptNarration', narration);
              this.$('#transcript_button').css('display', 'block');
            }
          });
          this.setPageTitle();
          const readyToLoad = () =>
            blocksView.isLoaded() && (!modulesBlocksView || (modulesBlocksView && modulesBlocksView.isLoaded()));
          const blocksLoaded = () => {
            if (this.model.get('state') !== 'initialized') {
              return;
            }
            this.setState('loaded');

            BlockOrderService.generateOrderMap(blocksView);
            if (BlockOrderService.getCurrentOrder() !== 'complete') {
              this.trigger('page:state:change', this);
            }
            const animateds = $('.animated');
            const playPage = () => {
              this.$el.attr('tabindex', '-1');
              $('#page-loading').text('').attr('aria-hidden', true);
              setTimeout(() => {
                $(window).scrollTop(0);
              }, 0);
              AniJS.run();
              AOS.init();

              if (this.model.get('startAnimation')) {
                AnimationService.queueAnimationsRun();
              }
              animateds.each((i, el) => {
                const classes = el.className;
                el.className = '';
                setTimeout(() => (el.className = classes), 0);
              });
              this.setState('playing');
            };

            const pageCustomizations = EF.customizations.getByKeyAndPage(
              'page-content-customization',
              this.model.get('moduleKey'),
              this.model.get('activityKey'),
              this.model.get('key')
            );

            const customContentView = new CustomContentView({
              region: 'custom-content',
              collection: new Chaplin.Collection(pageCustomizations),
            });
            customContentView.on('done', () => {
              if (this.model.get('instructions')) {
                const feedback = new Feedback(this.model.get('instructions'));
                this.renderFeedback(feedback, { unloading: playPage });
              } else {
                playPage();
              }
            });
            customContentView.render();
            this.subview('custom-content', customContentView);
          };
          if (readyToLoad()) {
            blocksLoaded();
          } else {
            this.listenTo(blocksView, 'block:state:loaded', () => readyToLoad() && blocksLoaded());
            if (modulesBlocksView) {
              this.listenTo(modulesBlocksView, 'block:state:loaded', () => readyToLoad() && blocksLoaded());
            }
          }
        });
    }
  },

  setMainRole: function () {
    // Defer to next tick so any wrapper/`<main>` injected by other systems is in place first
    setTimeout(() => {
      if (this.$el && this.$el.closest('[role="main"], main').length === 0) {
        this.$el.find('#page-container').attr('role', 'main');
      }
    }, 0);
  },

  setPrevNextTitle() {
    const prev = PageService.getPreviousPage();
    const next = PageService.getNextPage();
    if (prev) {
      SessionStorageService.setItem('prevTitle', LocaleService.t(prev.get('title')));
    }
    if (next) {
      SessionStorageService.setItem('nextTitle', LocaleService.t(next.get('title')));
    }
  },

  getBlocksNarration(blocks) {
    const transcript = [];
    //Adding absent, present, parameters as transcript was not showing up when audio tag is passed from inside these key
    const nestedItems = ['blocks', 'feedback', 'absent', 'present', 'parameters'].concat(this.nested);
    blocks = [].concat(blocks.models || blocks);
    blocks.forEach(block => {
      if ((block.get && block.get('narration')) || block.narration) {
        transcript.push(LocaleService.t((block.get && block.get('narration')) || block.narration));
      }
      nestedItems.forEach(item => {
        if (block.attributes && block.attributes[item]) {
          transcript.push(...this.getBlocksNarration(block.attributes[item]));
        } else if (block[item]) {
          transcript.push(...this.getBlocksNarration(block[item]));
        }
      });
      if (blocks.subviews) {
        blocks.subviews.forEach(view => {
          if (view instanceof BlocksView) {
            transcript.push(...this.getBlocksNarration(view));
          }
        });
      }
    });
    return transcript;
  },

  onReplay: function () {
    this.setState('playing');
  },
  unload: function () {
    this.setState('unloading');
    this.unsubscribeAllEvents();
  },
  renderFeedback: function (feedback, callbacks) {
    FeedbackService.displayFeedback(this, feedback, callbacks);
  },
  renderAlert: function (type, title, body, icon, visibility, timeout) {
    const alertView = new AlertView({
      region: 'alert',
      model: new Chaplin.Model({
        type,
        ico: icon,
        title,
        body,
        visibility,
        timeout,
      }),
    });
    this.subview('alert', alertView);
    $('.e-sign-alert').empty();
    if (type === 'alertBox.alertSuccess') {
      $('.e-sign-alert').text(
        `${LocaleService.t('alertBox.alertSuccessHeader')} ${LocaleService.t('alertBox.alertSuccessText')}`
      );
    }
    if (type === 'alertBox.alertFailure') {
      $('.e-sign-alert').text(
        `${LocaleService.t('alertBox.alertFailureHeader')} ${LocaleService.t('alertBox.alertFailureText')}`
      );
    }
  },
  renderAudioStarterAlert: function () {
    const alertView = new AudioStarterAlertView();
    this.subview('audio-starter-alert', alertView);
  },
  closeAlert: function () {
    this.subviewsByName?.alert?.dispose();
    $('.alert').html('');
  },
  closeAudioStarterAlert: function () {
    this.subviewsByName['audio-starter-alert'].dispose();
    $('.audio-starter-alert').html('');
  },
  closeTranscript() {
    if (this.subviewsByName.siteTranscript) {
      this.subviewsByName.siteTranscript.dispose();
    }
    this.$('#transcript_button').removeClass('open');
    this.$('.transcript').hide();
    this.transcriptShowing = false;
  },
  setPageTitle: function () {
    const titleAr = [
      LocaleService.t('ModuleName') !== 'ModuleName'
        ? LocaleService.t('ModuleName')
        : LocaleService.t(EF.module.get('title')),
      LocaleService.t(EF.module.currentActivity.get('title')),
      LocaleService.t(EF.module.currentActivity.currentPage.get('title')) ||
      LocaleService.t(this.model.get('page-title')),
    ];

    document.title = _.uniq(titleAr)
      .filter(t => t)
      .join(' | ');
  },
  setSkipLink: function () {
    //Use foundry skip-to-main-content link (#skipLink) if it exists
    if ($('#skipLink').length) {
      $('#skipLink').on('keydown', e => {
        KeybindingService.with(e).bind([Enter, Space], () => {
          e.preventDefault();
          this.skipToContent();
        });
      });
    }
    this.$el.on('click', '#skip-to-main-content', e => {
      e.preventDefault();
      this.skipToContent();
    });
  },
  skipToContent: function () {
    const container = $('#page-container').length ? '#page-container' : '#main-container';
    const $heading = $(`${container} :header:visible`).first();

    // Insert a visually-hidden focus anchor immediately before the first heading.
    // We cannot place this in the page template because #page-container starts empty —
    // blocks (including audio players, headings, etc.) are rendered into it dynamically.
    // We need this anchor to sit right before the heading in DOM order so that:
    //   - JAWS doesn't announce the heading twice (which happens when focusing it directly)
    //   - NVDA doesn't read all preceding content like audio players (which happens when
    //     focusing the container, since the audio player appears before the heading in DOM)
    let $anchor = $('#skip-content-anchor');
    if (!$anchor.length) {
      $anchor = $('<span id="skip-content-anchor" class="visually-hidden" tabindex="-1"></span>');
    }

    if ($heading.length) {
      $anchor.insertBefore($heading);
    } else {
      $(`${container}`).prepend($anchor);
    }

    // Use a brief timeout to prevent a double-announcement bug in ChromeVox.
    // This decouples the focus action from the click event that triggered it.
    setTimeout(function () {
      $anchor.trigger('focus');
    }, 100);
  },
  blockCompleted: function (block) {
    BlockOrderService.updateOrderMap(block, this);

    if (this.subviewsByName.blocks.isComplete()) {
      //TODO: this will fire regardless of if progress saves, which might be OK, but should confirm
      this.completePage();
    }
  },
  dispose: function () {
    BlockOrderService.reset();
    if (this.completionTimeout) {
      clearTimeout(this.completionTimeout);
    }
    if (this.pageTimerService) {
      this.pageTimerService.clear();
    }
    if (this.disposed || this.disposing) {
      return;
    }
    if (this.model && (this.model.get('transition') || CourseSettingsService.get('transitionAll'))) {
      this.disposing = true;
      this.keepElement = true;
      this.keepSubviews(true);
      const $el = this.$el;
      const key = this.model.get('key');
      $el.on('animationstart', () => {
        $el.on('animationend', () => {
          console.log(`finished animation out on ${key}; disposing`); //eslint-disable-line no-console
          $el.remove();
        });
      });
      const transitionOutDir = this.model.get('transition-out') || 'forward';
      $el
        .removeClass('transition-in-back')
        .removeClass('transition-in-forward')
        .addClass(`transition-out-${transitionOutDir}`);
      View.prototype.dispose.apply(this, arguments);
    } else {
      this.keepSubviews(true);
      View.prototype.dispose.apply(this, arguments);
    }
  },
  completePage: function () {
    //TODO: review this in relation to the existing events in EF
    if (this.completionTimeout) {
      clearTimeout(this.completionTimeout);
    }
    if (CourseSettingsService.get('trackPageTimes') && !EF.options.local) {
      this.pageTimerService.save({
        page_key: this.model.get('key'),
        activity_key: this.model.get('activityKey'),
        module_key: this.model.get('moduleKey'),
      });
    }
    this.model.set('completed', true);
    ContentProvider.PageService.saveProgress(this);
    this.setState('completed');
  },
  stateCallbacks: {
    completed: function () {
      if (this.model.get('completedFeedback') && !this.completionTimerExpired) {
        const feedback = new Feedback(this.model.get('completedFeedback'));
        if (this.model.get('forwardOnComplete') && !this.willBeSkipped) {
          this.renderFeedback(feedback, {
            afterRemoved: () => {
              Chaplin.mediator.publish('page:navigate', this.forwardKey());
            },
          });
        } else {
          this.renderFeedback(feedback);
        }
      } else {
        if (this.model.get('forwardOnComplete') && !this.willBeSkipped) {
          Chaplin.mediator.publish('page:navigate', this.forwardKey());
        }
      }
      if (Object.isExtensible(this)) {
        this.completionTimerExpired = false;
      }
    },
    unloading: function () {
      this.setState('unloaded');
    },
    unloaded: function () {
      this.dispose();
    },
  },

  setState: function (state) {
    if (this.model) {
      if (this.$el) {
        this.$el.removeClass(this.model.get('state'));
        this.$el.addClass(state);
      }
      this.model.set('state', state);
    }

    const callback = this.stateCallbacks[state] ? _.bind(this.stateCallbacks[state], this) : null;
    const hook = this.script && this.script[state] ? _.bind(this.script[state], this.script) : null;

    if (hook && callback) {
      if (this.script[state].length === 2) {
        hook(this, callback);
      } else {
        hook(this);
        callback();
      }
    } else if (hook) {
      hook(this);
    } else if (callback) {
      callback();
    }
  },
  forwardKey: function () {
    return this.model.get('navigation') && this.model.get('navigation').forward
      ? this.model.get('navigation').forward
      : 'forward';
  },
});

export default PageView;
